module.exports = __webpack_public_path__ + "static/media/project.4c3d159f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/project.svg
// module id = 1301
// module chunks = 0